// The English catalogue is the source every other locale mirrors and the
// type every `useTranslations` key is checked against (see next-intl.d.ts).
// One file per area so parallel work never edits the same file; add a new
// area here and in every other locale's index.
import agreement from "./agreement.json";
import apply from "./apply.json";
import authFrame from "./authFrame.json";
import authGate from "./authGate.json";
import home from "./home.json";
import inbox from "./inbox.json";
import join from "./join.json";
import requests from "./requests.json";
import script from "./script.json";
import settings from "./settings.json";
import shell from "./shell.json";
import signIn from "./signIn.json";
import submit from "./submit.json";
import updates from "./updates.json";
import videos from "./videos.json";

export default {
  agreement,
  apply,
  authFrame,
  authGate,
  home,
  inbox,
  join,
  requests,
  script,
  settings,
  shell,
  signIn,
  submit,
  updates,
  videos,
};
